module.exports = __webpack_public_path__ + "static/img/02.8461ad1b.webp";